import React from 'react';
import FileSaver from 'file-saver';
import { FaFilePdf } from 'react-icons/fa';
import config from '@/config';
import messages from './interactionMessages';
import api from '@/shared/api';
import Button from '@/shared/components/Button';
import utils from '@/shared/utils/adminpulse';

const exportSingleInteractionToPdf = (interaction, intl) => {
  const languageCode = intl.locale;
  const endpoint = `${config.appUrls.interactions}/api/interactions/${interaction.id}/pdf/${
    languageCode.split('-')[0]
  }`;

  return api.base
    .get(endpoint, {
      responseType: 'arraybuffer',
    })
    .then(result => {
      const fileType = result.headers['content-type'];
      const fileName = interaction.title ? `${interaction.title}.pdf` : 'untitled.pdf';
      const blob = new Blob([result.data], {
        type: fileType,
      });
      FileSaver.saveAs(blob, fileName);
      return true;
    })
    .catch(error => {
      const errorObject = utils.arrayBufferToObject(error.response && error.response.data);
      handleHttpError(intl)(errorObject);
      return '';
    });
};

const ExportInteractionPdfButton = ({ interaction, intl, ...others }) => (
  <Button
    {...others}
    title={intl.formatMessage(messages.ExportToPdf)}
    onClick={() => exportSingleInteractionToPdf(interaction, intl)}
    showProgress
  >
    <FaFilePdf className="react-icon red" />
  </Button>
);
export default ExportInteractionPdfButton;
